import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./AuthProvider";

export default function RequireAuth({ adminOnly }: { adminOnly?: boolean }) {
    const { token, isTokenValid, isAdmin } = useAuth();

    if (!token || !isTokenValid(token)) return <Navigate to="/login" replace />;

    if (adminOnly && !isAdmin) return <Navigate to="/app/dashboard" replace />;
    if (!adminOnly && isAdmin) return <Navigate to="/admin/dashboard" replace />;

    return <Outlet />;
}
